/* eslint-disable no-console */
import {InfoCircleOutlined} from '@ant-design/icons';
import {Col, Form, Select} from 'antd';
import useFormInstance from 'antd/es/form/hooks/useFormInstance';
import React, {useContext, useEffect, useState} from 'react';

import {ReactComponent as YearCalender} from '../../assets/yearCalender.svg';
import {CommonErrors} from '../../constants/Common';
import {EfdbName} from '../../constants/efdbNameConstants';
import FilteredUnit from '../../constants/FilteredUnit';
import InformativeText from '../../constants/InformativeText';
import SelectedCountryContext from '../../pages/configurator/orgFacility/Constants/SelectedCountryContext';
import {sortYearOptions} from '../../pages/orgManager/Utils/InfraStructureProfile/constant/sorYear';
import NumberInput from '../../shared/NumberInput';
import yearFilterArray from '../../shared/YearFilterArray';
import useCompanyStore from '../../store/companyStore/companyDetailsStore';
import useJSONStore from '../../store/StaticJson/jsonStore';
import useUserStore from '../../store/userStore/userStore';
import {hasUserRole, UserRole} from '../../utils/commonFunctions';
import RegEx from '../../utils/FormUtils/RegEx';
import FormListComp from '../DrawerForm/Utils/FormListComp';

import {AverageKey, AverageLabel} from './Constants/IP/AverageKeyLabel';
import {facilityKeyLabel, yearKeyLabel} from './Constants/IP/commonKeyLabel';
import {filterSelectOptions} from './Utils/commonFunctions';
import CapGoodsSupplierSpec from './Utils/TableListForm/CapGoodsSupplierSpec';

const AverageForm: React.FC<{
  suppliers: any;
  setSubmitDisabled: React.Dispatch<React.SetStateAction<boolean>>;
  isAverage: boolean;
  currentStep?: number;
  data: any;
  setFormFacility: React.Dispatch<React.SetStateAction<string>>;
  setFormSelectedYear: React.Dispatch<React.SetStateAction<string>>;
  defaultDisplayStep?: boolean;
}> = ({
  suppliers,
  isAverage,
  currentStep,
  data,
  setFormFacility,
  setFormSelectedYear,
  defaultDisplayStep = false
}) => {
  const isCompanyUserOrAdmin =
    hasUserRole(UserRole.Company_Admin) || hasUserRole(UserRole.Company_user);
  const capitalGoods = useJSONStore.getState().capitalGoods;

  const capAverInfo = InformativeText?.IP?.capitalGoods;
  const userDetails = useUserStore.getState().userDetails;

  const {facilityId, selectedYear, selectedCountry} = useContext(
    SelectedCountryContext
  );
  const facilityDetails = useCompanyStore.getState().facilityDetails;
  const [formSelectedCountry, setFormSelectedCountry] = useState<string>('');
  const [facilityOpt, setFacilityOpt] = useState<any[]>([]);

  const {getFieldValue, setFields} = useFormInstance();

  const [selectedCapGoods, setSelectedCapGoods] = useState<any>(
    capitalGoods?.find((item: any) => {
      return (
        item?.value ===
        (getFieldValue(AverageKey.CAPITAL_GOODS) ??
          data?.[AverageKey.CAPITAL_GOODS])
      );
    })?.value
  );

  useEffect(() => {
    setFacilityOpt(
      facilityDetails?.[
        getFieldValue(yearKeyLabel.key) ?? selectedYear ?? ''
      ]?.filter((item: any) => {
        return !item.isLeased;
      }) ?? []
    );
  }, []);

  useEffect(() => {
    setFormSelectedCountry(
      facilityOpt.find((item: any) => {
        return (
          item?._id === (getFieldValue(facilityKeyLabel.key) ?? facilityId)
        );
      })?.country
    );
  }, [facilityOpt]);

  // const {selectedCountry, setSelectedCountry} = useContext(
  //   SelectedCountryContext
  // );

  const [yearOptions, setYearOptions] = useState<any[]>([]);

  useEffect(() => {
    setYearOptions(
      yearFilterArray(
        facilityDetails,
        !isCompanyUserOrAdmin ? userDetails?.facility : undefined,
        false
      )
    );
  }, []);

  useEffect(() => {
    setFacilityOpt(
      facilityDetails?.[
        getFieldValue(yearKeyLabel.key) ?? selectedYear ?? ''
      ]?.filter((item: any) => {
        return !item.isLeased;
      }) ?? []
    );
  }, []);

  return (
    <>
      {(currentStep === 0 || defaultDisplayStep) && (
        <>
          <Col className="gutter-row">
            <Form.Item
              name={yearKeyLabel.key}
              label={yearKeyLabel.label}
              labelCol={{span: 24}}
              initialValue={selectedYear}
              hidden={defaultDisplayStep}
            >
              <Select
                placeholder={yearKeyLabel.label}
                options={sortYearOptions(yearOptions)}
                suffixIcon={<YearCalender />}
                disabled={getFieldValue('_id') !== undefined}
                onChange={(e) => {
                  setFormSelectedYear(e);
                  setFacilityOpt(
                    facilityDetails?.[e]?.filter((item: any) => {
                      return !item.isLeased;
                    }) ?? []
                  );
                  if (getFieldValue(facilityKeyLabel.key)) {
                    setFields([
                      {
                        name: facilityKeyLabel.key,
                        value: undefined,
                        errors: ['Please select facility again']
                      }
                    ]);
                  }
                }}
              />
            </Form.Item>
          </Col>
          {isCompanyUserOrAdmin && (
            <>
              <Col className="gutter-row">
                <Form.Item
                  name={facilityKeyLabel.key}
                  label={facilityKeyLabel.label}
                  hidden={defaultDisplayStep}
                  labelCol={{span: 24}}
                  rules={[
                    {
                      required: true,
                      message: CommonErrors.mandatory(facilityKeyLabel.label)
                    }
                  ]}
                  initialValue={facilityId}
                >
                  <Select
                    placeholder={facilityKeyLabel.label}
                    options={
                      facilityOpt?.map((item: any) => {
                        return {label: item.name, value: item._id};
                      }) ?? []
                    }
                    disabled={getFieldValue('_id') !== undefined}
                    onChange={(e) => {
                      setFormFacility(e);
                      if (getFieldValue(AverageKey.CAPITAL_GOODS)) {
                        setFields([
                          {
                            name: AverageKey.CAPITAL_GOODS,
                            errors: [CommonErrors.selectAgain],
                            value: undefined
                          }
                        ]);
                      }
                      if (
                        !isAverage &&
                        getFieldValue(AverageKey.SUPPLIER_DATA)
                      ) {
                        setFields([
                          {
                            name: AverageKey.SUPPLIER_DATA,
                            errors: [CommonErrors.selectAgain],
                            value: [{[AverageKey.SUPPLIER_NAME]: undefined}]
                          }
                        ]);
                      }
                      setFormSelectedCountry(
                        facilityDetails[
                          getFieldValue(yearKeyLabel.key) ?? ''
                        ]?.find((item: any) => {
                          return item._id === e;
                        })?.country
                      );
                    }}
                  />
                </Form.Item>
              </Col>
            </>
          )}
        </>
      )}
      {(currentStep === 1 || defaultDisplayStep) && (
        <>
          <Col className="gutter-row">
            <Form.Item
              name={AverageKey.CAPITAL_GOODS}
              rules={[
                {
                  required: true,
                  message: CommonErrors.mandatory(AverageLabel.CAPITAL_GOODS)
                }
              ]}
              label={AverageLabel.CAPITAL_GOODS}
              labelCol={{span: 24}}
            >
              <Select
                showSearch
                allowClear
                className="select"
                placeholder={`Choose ${AverageLabel.CAPITAL_GOODS}`}
                options={capitalGoods.filter(
                  (item) => item?.dbName === EfdbName.eeio
                )}
                filterOption={filterSelectOptions}
                onChange={(e) => {
                  setSelectedCapGoods(e);
                  if (!isAverage && getFieldValue(AverageKey.SUPPLIER_DATA)) {
                    setFields([
                      {
                        name: AverageKey.SUPPLIER_DATA,
                        errors: [CommonErrors.selectAgain],
                        value: [{[AverageKey.SUPPLIER_NAME]: undefined}]
                      }
                    ]);
                  }
                }}
              />
            </Form.Item>
          </Col>
          <Col className="gutter-row">
            <Form.Item
              name={AverageKey.NO_UNITS}
              label={AverageLabel.NO_UNITS}
              rules={[
                {
                  pattern: RegEx.nonDecimal,
                  message: CommonErrors.nonDecimalNonNegative
                }
              ]}
              initialValue={null}
              labelCol={{span: 24}}
            >
              <NumberInput placeholder={`Enter ${AverageLabel.NO_UNITS}`} />
            </Form.Item>
          </Col>
          <Col className="gutter-row">
            <Form.Item
              name={AverageKey.COST_EACH_UNITS}
              label={AverageLabel.COST_EACH_UNITS}
              initialValue={null}
              labelCol={{span: 24}}
              rules={[
                {
                  pattern: RegEx.nonDecimal,
                  message: CommonErrors.nonDecimalNonNegative
                }
              ]}
            >
              <NumberInput
                addonBefore={
                  FilteredUnit(formSelectedCountry ?? selectedCountry).currency
                }
                placeholder={`Enter ${AverageLabel.COST_EACH_UNITS}`}
              />
            </Form.Item>
          </Col>
          {isAverage && (
            <Col className="gutter-row">
              <Form.Item
                name={AverageKey.WEIGHT_OF_EACH_UNIT}
                label={AverageLabel.WEIGHT_OF_EACH_UNIT}
                initialValue={null}
                labelCol={{span: 24}}
                rules={[
                  {
                    pattern: RegEx.twoDigitDecimal,
                    message: CommonErrors.twoDigitPositive
                  }
                ]}
              >
                <NumberInput
                  addonAfter={
                    FilteredUnit(formSelectedCountry ?? selectedCountry).weight
                  }
                  placeholder={`Enter ${AverageLabel.WEIGHT_OF_EACH_UNIT}`}
                />
              </Form.Item>
            </Col>
          )}
          <Col className="gutter-row">
            <Form.Item
              name={AverageKey.POWER_CAPACITY}
              label={AverageLabel.POWER_CAPACITY}
              initialValue={null}
              labelCol={{span: 24}}
              rules={[
                {
                  pattern: RegEx.nonDecimal,
                  message: CommonErrors.nonDecimalNonNegative
                }
              ]}
              tooltip={{
                icon: <InfoCircleOutlined />,
                title: capAverInfo?.powerCap
              }}
            >
              <NumberInput
                addonAfter={
                  FilteredUnit(formSelectedCountry ?? selectedCountry)
                    .powerCapacity
                }
                placeholder={`Enter ${AverageLabel.POWER_CAPACITY}`}
              />
            </Form.Item>
          </Col>
          {!isAverage && (
            <FormListComp
              mainName={AverageKey.SUPPLIER_DATA}
              formComponent={
                <CapGoodsSupplierSpec
                  supplier={suppliers
                    ?.filter((item: any) => {
                      return item?.capitalGoodsSupplied?.includes(
                        selectedCapGoods ?? ''
                      );
                    })
                    ?.sort((a: any, b: any) => {
                      return a?.label < b?.label ? -1 : 1;
                    })}
                />
              }
            />
          )}
        </>
      )}
    </>
  );
};

export default AverageForm;
